import { Component, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IwgSelect } from 'src/app/shared/models/iwgselect.model';
import { IwgSelectService } from 'src/app/shared/services/iwgselect.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TeamSelectComponent),
  multi: true
};

@Component({
  selector: 'app-team-select',
  templateUrl: './team-select.component.html',
  styleUrls: ['./team-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class TeamSelectComponent implements ControlValueAccessor,OnChanges {

  @Input("preselected-item-id") preselectedItemId:any;
  @Input("refresh-on-preselect") refreshOnPreselect:boolean;
  @Input("filter-item-id-NOT") filterItemIdNOT;
  @Input() isRequired = false;

  isLoading:boolean = false;
  isOpen:boolean = false;
  items:IwgSelect[] = null;

  constructor(private selectService:IwgSelectService) { }
  ngOnChanges(changes: SimpleChanges){

    if ('preselectedItemId' in changes) {
        if(this.preselectedItemId != null){
          this.get(true);
        }
    }
  }
  get(setId=false){
    this.selectService.getTeams().subscribe(
      data=>{
        this.isLoading = false;
        this.items = data.data.Data;
        if(this.preselectedItemId != null && setId){
          this.value = this.items.find(item=>item.ID == this.preselectedItemId)
        }
      },
      err=>{
        this.isLoading = false;
        console.log(err);
      }
    );
  }
  private innerValue: any = '';
  get value(): any {return this.innerValue;};
  set value(v: any) {
      if (v !== this.innerValue) {
        this.innerValue = v;this.onChangeCallback(v);
      }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value;}}
  registerOnChange(fn: any) {this.onChangeCallback = fn;}
  registerOnTouched(fn: any) {this.onTouchedCallback = fn;}

  onOpen(event){
    this.isOpen = event;
    if(this.items && (!event || this.items.length>0)){
      return;
    }
    this.isLoading = true;
    this.get();
  }
  objectComparison = function( option, value ) : boolean {
    if (!option || !value) {
      return false;
    }
    return option.ID === value.ID;
  }
}
